/**
 * GENERATED by scripts/gen-asset-dimensions.mjs - do not edit by hand.
 * Real pixel dimensions of everything in public/assets, so next/image can
 * reserve the right box and build a correct srcset.
 */
export const ASSET_DIMENSIONS: Record<string, { width: number; height: number }> = {
  '/assets/a-b-testing-zoomed-in.png': { width: 1020, height: 813 },
  '/assets/blog-editor-zoomed-in.png': { width: 917, height: 853 },
  '/assets/booking-page-zoomed-in.png': { width: 1076, height: 681 },
  '/assets/chat-widget-zoomed-in.png': { width: 1071, height: 837 },
  '/assets/copilot-dashboard-page-zoomed-in-showing-chat.png': { width: 1012, height: 858 },
  '/assets/copilot-dashboard-page-zoomed-out.png': { width: 1891, height: 958 },
  '/assets/editable-pages-zommed-in.png': { width: 1101, height: 865 },
  '/assets/heatmap-zoomed-in.png': { width: 992, height: 893 },
  '/assets/kit-promo-poster.jpg': { width: 1920, height: 1080 },
  '/assets/landingdashboard.png': { width: 1895, height: 958 },
  '/assets/leads-page-zoomed-in.png': { width: 1057, height: 864 },
  '/assets/media-library-zoomed-in.png': { width: 1078, height: 810 },
  '/assets/newsletter-zoomed-in.png': { width: 1117, height: 826 },
  '/assets/product-page-zoomed-in.png': { width: 858, height: 832 },
  '/assets/service-page-zoomed-in.png': { width: 1057, height: 914 },
  '/assets/team-zoomed-in.png': { width: 1003, height: 496 },
  '/assets/visitors-page-zoomed-in.png': { width: 1056, height: 840 },
};

/** Falls back to a 16:10 box for an unknown (e.g. KIT-hosted) image. */
export function assetSize(src: string) {
  return ASSET_DIMENSIONS[src] ?? { width: 1600, height: 1000 };
}
